"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getAppendToElement = getAppendToElement;
var _utils = require("./utils");
var _isElement = _interopRequireDefault(require("lodash/isElement"));
function getAppendToElement(appendTo, node) {
  if (!appendTo) {
    return null;
  }
  if (typeof appendTo === 'string') {
    switch (appendTo) {
      case 'window':
      case 'viewport':
        return document.body;
      case 'scrollParent':
        return (0, _utils.getScrollParent)(node);
      default:
        return;
    }
  }
  if (typeof appendTo === 'function') {
    return getByPredicate(appendTo, node);
  }
  if ((0, _isElement.default)(appendTo)) {
    return appendTo;
  }
  return;
}
function getByPredicate(predicate, element) {
  if (!element) {
    return;
  }
  const node = searchParent(predicate, element);
  if (node) {
    return node;
  }
  return;
}
function searchParent(predicate, element) {
  if (!element) {
    return;
  }
  if (predicate(element)) {
    return element;
  }
  return searchParent(predicate, (0, _utils.getParentNode)(element));
}
//# sourceMappingURL=getAppendToElement.js.map